import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default (props) => {
  const { doUpdateItem, item, answerHandlerOpen } = props;

  const [JiraSettings, setJiraSettings] = useState({
    projectId: '',
    quantity: '',
    status: '',
  });

  useEffect(() => {
    if (item && item.jira) {
      setJiraSettings(item.jira);
    }
  }, [item]);

  const { i18n } = useTranslation();

  const UpdateItem = (payload) => {
    doUpdateItem({ ...item, ...payload });
  };

  const handleInputSettingsChange = (e) => {
    const { name, value } = e.target;
    const updatedSettings = { ...JiraSettings, [name]: value };

    setJiraSettings(updatedSettings);
    UpdateItem({ jira: updatedSettings });
  };

  const handleSelectVariavel = (name, value, variavel) => {
    const newValue = `${value}${variavel}`;
    const updatedSettings = { ...JiraSettings, [name]: newValue };

    setJiraSettings(updatedSettings);
    UpdateItem({ jira: updatedSettings });
  };

  return (
    <>
      <p className="handler-title">Listar Prioridades</p>
      <div className="common-form-group">
        <label>
        {i18n.t('Variável para vizualizar as prioridades')}
        </label>
        <input
          className="form-control mt-1"
          defaultValue="{jira.priority_list}"
          disabled
        />
      </div>

      <div className="common-form-group">
        <label>{i18n.t('Variável de mensagem do scape')}</label>
        <input
          className="form-control mt-1"
          defaultValue="{jira.response}"
          disabled
        />
      </div>

      <div className="common-form-group">
        <label>{i18n.t('Variável de código do scape')}</label>
        <input
          className="form-control mt-1"
          defaultValue="{jira.response_status}"
          disabled
        />
      </div>
    </>
  );
};
